/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLocationUp = createReactComponent("location-up", "IconLocationUp", [
  [
    "path",
    {
      d: "M12 18l-2 -4l-7 -3.5a.55 .55 0 0 1 0 -1l18 -6.5l-3.251 9.003",
      key: "svg-0"
    }
  ],
  ["path", { d: "M19 22v-6", key: "svg-1" }],
  ["path", { d: "M22 19l-3 -3l-3 3", key: "svg-2" }]
]);

export { IconLocationUp as default };
//# sourceMappingURL=IconLocationUp.js.map
